<template>
    <div class="customer__content">
        <toggle-card v-for="(contact, i) in displayValue" v-bind:key="i" v-bind:heading="getHeading(contact)" v-bind:can-delete="true"  v-on:delete="onDelete(contact, i)" v-bind:visibility="contact.visibility">
            <z-input
                v-model="contact.name" label="Имя" 
                v-validate="'required'" v-bind:required="true" 

                v-bind:name="('contact_name-' + i)"
                v-bind:id="('contact_name-' + i)"
                v-bind:data-vv-name="('contact_name-' + i)"
                v-bind:data-vv-scope="('contact-' + i)"
                v-bind:error="errors.first(('contact-' + i + '.contact_name-' + i))"
                data-vv-as=" "
            ></z-input>
            <div class="row">
                <z-input
                    v-model="contact.phone" label="Телефон" 
                    v-validate="{ required: true, regex: phoneValidate }" 
                    v-bind:mask="'+7 (999) 999-99-99'"
                    v-bind:required="true" class="col-6"

                    v-bind:name="('contact_phone-' + i)"
                    v-bind:id="('contact_phone-' + i)"
                    v-bind:data-vv-name="('contact_phone-' + i)"
                    v-bind:data-vv-scope="('contact-' + i)"
                    v-bind:error="errors.first(('contact-' + i + '.contact_phone-' + i))"
                    data-vv-as=" "
                ></z-input>
                <z-input
                    v-model="contact.email" label="E-Mail" type="email"
                    v-validate="{required: true, email: true}" v-bind:required="true"
                    v-bind:name="('contact_email-' + i)" class="col-6"
                    v-bind:id="('contact_email-' + i)"
                    v-bind:data-vv-name="('contact_email-' + i)"
                    v-bind:data-vv-scope="('contact-' + i)"
                    v-bind:error="errors.first(('contact-' + i + '.contact_email-' + i))"
                    data-vv-as=" "
                ></z-input>
            </div>
            <z-button class="md-primary md-dense" @click="saveContact(contact, i, ('contact-' + i))" fit-content no-margin>Сохранить</z-button>
        </toggle-card>
        <z-button @click="addContact" fit-content no-margin>Добавить контакт</z-button>
    </div>
</template>
<script>
    import ZInput  from '@/components/ZInput';
    import ZSelect from '@/components/ZSelect';
    import ZButton from '@/components/ZButton';
    import ToggleCard from '@/components/ToggleCard';
    export default {
        components: { ZInput, ToggleCard, ZSelect, ZButton },
        props: {
            value: {
                type: Array,
                default: () => {
                    return [];
                }
            },
            customerId: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                phoneValidate: /^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/,
                localValue: []
            }
        },
        created() {
            if (this.$props.value) this.localValue = Object.assign([], this.$props.value);
        },
        watch: {
            '$props.value' (newVal) {
                if (JSON.stringify(this.localValue) != JSON.stringify(newVal)) this.localValue = newVal;
            },
            'localValue' (newVal) {
                this.$emit('input', newVal);
            }
        },
        computed: {
            /**
             * Получение типов адресов
             */
            addressTypes() {
                return this.$store.state.address.address_types;
            },
            displayValue() {
                return this.localValue.map(item => {
                    if (typeof item.visibility == 'undefined') item.visibility = false;
                    return item;
                });
            }            
        },
        methods: {
            /**
             * Установка заголовка у контакта
             */
            getHeading(contact) {
                return [
                    contact.name  || null,
                    contact.phone || null,
                    contact.email || null
                ].filter(v => !!v).join(', ');
            },            
            /**
             * Добавление контакта
             */
            addContact() {
                if (!this.localValue) this.localValue = [];
                this.localValue.push({
                    name: null,
                    phone: null,
                    email: null,
                    sort: 100,
                    customer_id: this.$props.customerId,
                    visibility: true
                })
            },
            /**
             * Сохранение контакта
             */
            saveContact(contact, index) {
                this.$store.commit('showProgressBar', 'load-customer-card');
                this.$store.dispatch((contact.id ? 'customers/updateCustomerContacts' : 'customers/addCustomerContacts'), { contacts: contact }).then(contact => {
                    if (contact) this.$set(this.localValue, index, Object.assign({}, contact));
                }).finally(() => this.$store.commit('hideProgressBar', 'load-customer-card'));
            },
            /**
             * Удаление контакта
             */
            async removeContact(id, i) {
                if (id) {
                    this.$store.commit('showProgressBar', 'load-customer-card');
                    await this.$store.dispatch('customers/deleteCustomerContacts', { contact_id: id})
                        .finally(() => this.$store.commit('hideProgressBar', 'load-customer-card'));
                }

                this.localValue.splice(i, 1)
            },
            /**
             * Валидация
             */
            validate() {
                return this.$validator.validateAll();
            },
            /**
             * Модальное окно с удалением контакта
             */
            onDelete(contact, i) {
                this.$root.$emit(
                    'z-alert', 'Вы уверены в удалении контакта?', 'Действие необратимо!',
                    () => this.removeContact(contact.id, i)
                );
            }
        }
    }
</script>


// WEBPACK FOOTER //
// CustomerContacts.vue?59b1bd00